import axios from "axios";

const isLocalhost =
  Boolean(
    window.location.hostname === "localhost" ||
      window.location.hostname === "[::1]"
  ) || window.location.hostname.match(/^127(?:\.\d+){3}$/);

const API_BASE_URL = isLocalhost
  ? "http://localhost:5000" // Local development URL
  : "https://portalapi.aseries.in"; // Production URL

const api = axios.create({
  // withCredentials: true,
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  // Add a longer timeout if needed
  timeout: 10000,
});

export const login = async (credentials) => {
  try {
    const response = await api.post("/auth/login", credentials);
    console.log("Login response:", response.data);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.data instanceof FormData) {
      Object.assign(config.headers, { "Content-Type": "multipart/form-data" });
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error);

    if (error.response) {
      console.error("Response data:", error.response.data);
      console.error("Response status:", error.response.status);
    } else if (error.request) {
      console.error("No response received from server");
    } else {
      console.error("Request error:", error.message);
    }

    return Promise.reject(error);
  }
);

export default api;
